<template>
  <div>
    <div class="d-flex px-2 searchbar">
      <input
        class="borderless my-auto w-100 mr-3"
        :placeholder="searchPlaceholder"
        v-model="query"
        @input="onKeyUp"
      />
      <div @click="onSearch" class="d-flex">
        <icon
          name="Search"
          size="sm"
          class="ml-auto my-auto clickable icon-primary"
        ></icon>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import Icon from "components/Icon.vue";

@Component({ components: { Icon } })
export default class SearchBar extends Vue {
  private query?: string = null;
  private timeout?: any = null;

  @Prop({ required: false, default: "Cerca..." })
  searchPlaceholder?: string;

  @Prop({ required: false, default: 350 })
  inputTimeout: number;

  @Prop({ required: false, default: 3 })
  minSearchLength: number;

  onSearch() {
    this.$emit("search", this.query);
  }

  get isSearchable() {
    if (this.query == null) return false;
    return this.query.length >= this.minSearchLength;
  }

  emitSearch(term) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.$emit("search", term);
    }, this.inputTimeout);
  }

  onKeyUp(event) {
    if (this.isSearchable) {
      this.emitSearch(this.query);
    } else {
      this.emitSearch("");
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-input-placeholder {
  font-style: normal;
}
:-moz-placeholder {
  font-style: normal;
}
::-moz-placeholder {
  font-style: normal;
}
:-ms-input-placeholder {
  font-style: normal;
}

.searchbar {
  height: 40px;
}
</style>
